module.exports = __webpack_public_path__ + "img/empty-set.09aead48.svg";